import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Debug logging
console.log('Supabase Config Debug:');
console.log('VITE_SUPABASE_URL:', supabaseUrl);
console.log('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? `${supabaseAnonKey.substring(0, 10)}...` : 'undefined');
console.log('import.meta.env keys:', Object.keys(import.meta.env));

let supabase: any;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables:');
  console.error('VITE_SUPABASE_URL:', supabaseUrl);
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? 'present' : 'missing');
  console.warn('⚠️ Supabase connection will fail. Check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
  
  // Create a dummy client to prevent app crash
  supabase = createClient('https://dummy.supabase.co', 'dummy-key');
} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
  
  // Test the connection immediately
  supabase.from('template_departments').select('count', { count: 'exact', head: true })
    .then((result: { error: { message?: string } | null }) => {
      if (result.error) {
        console.error('❌ Supabase connection test failed:', result.error);
      } else {
        console.log('✅ Supabase connection test successful');
      }
    })
    .catch((err: unknown) => {
      console.error('❌ Supabase connection test exception:', err);
    });
}

// Add a global test function for debugging
(window as any).testSupabaseConnection = async () => {
  console.log('🧪 Testing Supabase connection...');
  
  try {
    // Test 1: Basic connection
    console.log('1️⃣ Testing basic connection...');
    const { data: testData, error: testError } = await supabase
      .from('template_departments')
      .select('*')
      .limit(1);
    
    if (testError) {
      console.error('❌ Basic connection failed:', testError);
      return false;
    }
    
    console.log('✅ Basic connection successful');
    console.log('📊 Sample data:', testData);
    
    // Test 2: Check table structure
    console.log('2️⃣ Testing table structure...');
    const { data: countData, error: countError } = await supabase
      .from('template_departments')
      .select('*', { count: 'exact', head: true });
    
    if (countError) {
      console.error('❌ Count query failed:', countError);
      return false;
    }
    
    console.log('✅ Table structure test successful');
    console.log('📊 Total records:', countData?.length || 0);
    
    return true;
  } catch (err) {
    console.error('❌ Connection test exception:', err);
    return false;
  }
};

export { supabase };

// Re-export types from shared for convenience
export type { Customer, Order, OrderItem, User, Service, OrderHistory } from '@shared/types';